<template>
    <div class="form-item">
        <label class="label-caption">Situação OS</label>
        <select :value="statusSelecionado" @change="atualizarTipo" class="form-control" v-bind="$attrs">
            <option v-for="tipo in lsTipos" :key="tipo.id" :value="tipo.id">{{ tipo.descricao }}</option>
        </select>
    </div>
</template>
  
<script>
export default {
    props: {
        statusSelecionado: {type: Number, default: null}
    },

    data() {
        return{
            lsTipos:[
                {id: 0, descricao: 'TODAS'},
                {id: 1, descricao: 'AGUARDANDO AUTORIZAÇÃO'},
                {id: 3, descricao: 'AGUARDANDO DEFINIÇÃO EQUIPAMENTO'},
                {id: 5, descricao: 'AGUARDANDO EXECUÇÃO'},
                {id: 7, descricao: 'INICIADA'},
                {id: 9, descricao: 'FINALIZADA'}
            ]
        };
    },

    methods: {
        atualizarTipo(event) {
            this.$emit('update:statusSelecionado', Number(event.target.value));
        }
    }
};
</script>